<script lang="ts">
  import type { Snippet } from 'svelte'

  interface Props {
    open: boolean
    onclose: () => void
    align?: 'left' | 'right'
    children: Snippet
  }
  const { open, onclose, align = 'right', children }: Props = $props()

  let panel = $state<HTMLDivElement | null>(null)

  $effect(() => {
    if (!open) return
    const onPointer = (event: MouseEvent) => {
      if (panel && !panel.contains(event.target as Node)) onclose()
    }
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onclose()
    }
    // Deferred so the click that opened the menu does not immediately close it.
    const id = setTimeout(() => document.addEventListener('click', onPointer), 0)
    document.addEventListener('keydown', onKey)
    panel?.querySelector<HTMLElement>('button, a')?.focus()
    return () => {
      clearTimeout(id)
      document.removeEventListener('click', onPointer)
      document.removeEventListener('keydown', onKey)
    }
  })
</script>

{#if open}
  <div class="menu {align}" bind:this={panel} role="menu" tabindex="-1">
    {@render children()}
  </div>
{/if}

<style>
  .menu {
    position: absolute;
    top: calc(100% + 4px);
    z-index: 40;
    min-width: 230px;
    max-height: 70dvh;
    overflow-y: auto;
    padding: var(--space-1);
    border: 1px solid var(--border);
    border-radius: var(--radius);
    background: var(--surface);
    box-shadow: var(--shadow-2);
    animation: pop var(--dur-fast) var(--ease);
  }
  .right {
    right: 0;
  }
  .left {
    left: 0;
  }
  @keyframes pop {
    from {
      transform: translateY(-4px);
      opacity: 0;
    }
  }
</style>
